import {Trans} from '@lingui/macro'
import type {FC} from 'react'
import {Link as RouterLink} from 'react-router-dom'
import styled from 'styled-components'

import {
    Button,
    Inline,
    ModalTitle,
    ModalContent,
    ModalActions,
    Stack,
    tokens,
} from '@pleo-io/telescope'

import CheckmarkImage from './images/CheckmarkPlan.svg'

const CheckmarkWrapper = styled.div`
    padding-top: ${tokens.spacing14};
`

const CheckCircle = styled.div`
    background: ${tokens.shade800};
    width: ${tokens.spacing60};
    height: ${tokens.spacing60};
    border-radius: ${tokens.circle};
`

const Title3XL = styled.text`
    font-size: ${tokens.font3XLarge};
`

interface ConfirmPlanModalProps {
    onDismiss: () => void
}

const ConfirmPlanModal: FC<ConfirmPlanModalProps> = ({onDismiss}) => {
    return (
        <>
            <ModalContent>
                <Stack align="center">
                    <CheckCircle>
                        <CheckmarkWrapper>
                            <img src={CheckmarkImage} alt="" height={45} />
                        </CheckmarkWrapper>
                    </CheckCircle>
                </Stack>
            </ModalContent>
            <ModalTitle>
                <Title3XL>
                    <Trans>Your plan has been updated to Pleo Free</Trans>
                </Title3XL>
            </ModalTitle>
            <ModalActions>
                <Stack space={20} align="center">
                    <Inline space={16}>
                        <Button
                            variant="secondary"
                            as={RouterLink}
                            to="/settings/general/billing"
                            onClick={() => onDismiss()}
                        >
                            <Trans>View billing</Trans>
                        </Button>
                        <Button variant="primary" onClick={() => onDismiss()}>
                            <Trans>Done</Trans>
                        </Button>
                    </Inline>
                </Stack>
            </ModalActions>
        </>
    )
}

export default ConfirmPlanModal
